(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-team"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMouseDrag = (scope) => {
      scope.querySelectorAll('.about-team__slider').forEach((slider) => {
        if (slider.dataset.mouseDragInitialized === 'true') return;

        slider.dataset.mouseDragInitialized = 'true';

        let activePointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let isDragging = false;

        const finishDrag = () => {
          const pointerId = activePointerId;

          activePointerId = null;
          isDragging = false;
          slider.classList.remove('is-dragging');

          if (pointerId !== null && slider.hasPointerCapture(pointerId)) {
            slider.releasePointerCapture(pointerId);
          }
        };

        slider.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (slider.scrollWidth <= slider.clientWidth) return;

          activePointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = slider.scrollLeft;
          isDragging = false;
          slider.setPointerCapture(event.pointerId);
        });

        slider.addEventListener('pointermove', (event) => {
          if (event.pointerId !== activePointerId) return;

          const distance = event.clientX - startX;

          if (!isDragging && Math.abs(distance) >= 4) {
            isDragging = true;
            slider.classList.add('is-dragging');
          }

          if (!isDragging) return;

          event.preventDefault();
          slider.scrollLeft = startScrollLeft - distance;
        });

        slider.addEventListener('pointerup', finishDrag);
        slider.addEventListener('pointercancel', finishDrag);
        slider.addEventListener('lostpointercapture', finishDrag);
      });
    };

    const initialize = () => initializeMouseDrag(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initializeMouseDrag(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner-swiper"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scheduledScopes = new WeakSet();

    function waitForSwiper(callback, attempt = 0) {
      if (typeof window.Swiper === 'function') {
        callback();
        return;
      }

      if (attempt >= 120) return;

      window.setTimeout(() => waitForSwiper(callback, attempt + 1), 50);
    }

    function init(scope) {
      scope.querySelectorAll('[data-home-banner]').forEach((slider) => {
        const pagination = slider.querySelector('.banner__swiper-pagination');
        const slideCount = slider.querySelectorAll('.swiper-slide').length;
        const hasMultipleSlides = slideCount > 1;

        if (slider.swiper) {
          slider.swiper.update();

          if (hasMultipleSlides && slider.swiper.autoplay) {
            slider.swiper.autoplay.start();
          }

          return;
        }

        new window.Swiper(slider, {
          slidesPerView: 1,
          autoHeight: slider.dataset.autoHeight === 'true',
          allowTouchMove: hasMultipleSlides,
          autoplay: hasMultipleSlides
            ? {
                delay: 4500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }
            : false,
          effect: 'fade',
          rewind: hasMultipleSlides,
          speed: 1000,
          pagination: pagination
            ? {
                el: pagination,
                clickable: true
              }
            : undefined
        });
      });
    }

    function scheduleInit(scope) {
      if (!scope || scheduledScopes.has(scope)) return;

      scheduledScopes.add(scope);

      waitForSwiper(() => {
        scheduledScopes.delete(scope);
        init(scope);
      });
    }

    function destroy(scope) {
      if (!scope) return;

      scope.querySelectorAll('[data-home-banner]').forEach((slider) => {
        if (!slider.swiper) return;
        slider.swiper.destroy(true, true);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scheduleInit(document), { once: true });
    } else {
      scheduleInit(document);
    }

    document.addEventListener('shopify:section:load', (event) => scheduleInit(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-custom-process"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var selector = '[data-home-overlay-reveal]';
    var mediaQuery = window.matchMedia('(min-width: 1025px) and (prefers-reduced-motion: no-preference)');
    var state = window.__homeOverlayReveal || {
      loadPromise: null,
      triggers: [],
      styledElements: []
    };

    window.__homeOverlayReveal = state;
    state.loadPromise = state.loadPromise || null;
    state.triggers = state.triggers || [];
    state.styledElements = state.styledElements || [];
    state.tweens = state.tweens || [];
    state.lenis = state.lenis || null;
    state.lenisRaf = state.lenisRaf || null;

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src="' + src + '"]');

        if (existing) {
          if (existing.dataset.loaded === 'true') {
            resolve();
          } else {
            existing.addEventListener('load', resolve, { once: true });
            existing.addEventListener('error', reject, { once: true });
          }

          return;
        }

        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = function () {
          script.dataset.loaded = 'true';
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    function loadGsap() {
      if (window.gsap && window.ScrollTrigger) {
        return Promise.resolve();
      }

      if (!state.loadPromise) {
        state.loadPromise = loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js')
          .then(function () {
            return loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js');
          });
      }

      return state.loadPromise;
    }

    function storeElementStyles(element) {
      var isStored = state.styledElements.some(function (item) {
        return item.element === element;
      });

      if (isStored) {
        return;
      }

      state.styledElements.push({
        element: element,
        position: element.style.position,
        zIndex: element.style.zIndex
      });
    }

    function restoreElementStyles() {
      state.styledElements.forEach(function (item) {
        item.element.style.position = item.position;
        item.element.style.zIndex = item.zIndex;
      });

      state.styledElements = [];
    }

    function getOverlayParts(section) {
      var wrapper = section.closest('.shopify-section') || section;
      var previous = wrapper.previousElementSibling;

      while (previous && !previous.classList.contains('shopify-section')) {
        previous = previous.previousElementSibling;
      }

      if (!previous) {
        return null;
      }

      return {
        section: section,
        wrapper: wrapper,
        previous: previous
      };
    }

    function setOverlayLayer(parts) {
      storeElementStyles(parts.wrapper);
      storeElementStyles(parts.previous);

      parts.wrapper.style.position = 'relative';
      parts.wrapper.style.zIndex = '5';
      parts.previous.style.position = 'relative';
      parts.previous.style.zIndex = '1';
    }

    function clearOverlayReveal() {
      if (state.lenisRaf) {
        window.cancelAnimationFrame(state.lenisRaf);
        state.lenisRaf = null;
      }

      if (state.lenis) {
        state.lenis.destroy();
        state.lenis = null;
      }

      state.tweens.forEach(function (tween) {
        if (tween && tween.scrollTrigger) {
          tween.scrollTrigger.kill();
        }

        if (tween && tween.kill) {
          tween.kill();
        }
      });

      state.tweens = [];

      state.triggers.forEach(function (trigger) {
        if (trigger && trigger.kill) {
          trigger.kill(true);
        }
      });

      state.triggers = [];
      document.querySelectorAll(selector).forEach(function (section) {
        section.classList.remove('is-home-overlay-active');
      });
      restoreElementStyles();
    }

    function setupOverlayReveal() {
      clearOverlayReveal();

      if (!mediaQuery.matches) {
        return;
      }

      loadGsap().then(function () {
        if (!window.gsap || !window.ScrollTrigger) {
          return;
        }

        window.gsap.registerPlugin(window.ScrollTrigger);

        document.querySelectorAll(selector).forEach(function (section) {
          var parts = getOverlayParts(section);

          if (!parts) {
            return;
          }

          setOverlayLayer(parts);

          var trigger = window.ScrollTrigger.create({
            trigger: parts.wrapper,
            start: 'top bottom',
            end: 'top top',
            pin: parts.previous,
            pinSpacing: false,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            onEnter: function () {
              section.classList.add('is-home-overlay-active');
            },
            onEnterBack: function () {
              section.classList.add('is-home-overlay-active');
            },
            onLeave: function () {
              section.classList.remove('is-home-overlay-active');
            },
            onLeaveBack: function () {
              section.classList.remove('is-home-overlay-active');
            },
            onUpdate: function (self) {
              section.classList.toggle('is-home-overlay-active', self.progress > 0 && self.progress < 1);
            }
          });

          state.triggers.push(trigger);
        });

        window.ScrollTrigger.refresh();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupOverlayReveal, { once: true });
    } else {
      setupOverlayReveal();
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(state.resizeTimer);
      state.resizeTimer = window.setTimeout(setupOverlayReveal, 180);
    });

    document.addEventListener('shopify:section:load', setupOverlayReveal);
    document.addEventListener('shopify:section:unload', setupOverlayReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-door-signs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const states = new WeakMap();
    const DESKTOP_MIN_WIDTH = 1025;
    const MIN_PROGRESS_SCALE = 0.1;
    const RESTING_SCALE = 1;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function getStickyOffset() {
      const value = getComputedStyle(document.documentElement).getPropertyValue('--lc-announcement-offset');
      return Math.max(Number.parseFloat(value) || 0, 0);
    }

    function reset(state, section) {
      state.cards.forEach((card) => {
        card.style.transform = '';
        card.style.zIndex = '';
      });

      state.copyLayers.forEach((copy, index) => {
        copy.style.opacity = '';
        copy.style.transform = '';
        copy.classList.toggle('is-active', index === 0);
      });

      if (state.progress) state.progress.style.transform = `scaleX(${MIN_PROGRESS_SCALE})`;
      if (state.pin) state.pin.style.height = '';
      section.style.minHeight = '';
    }

    function update(section) {
      const state = states.get(section);
      if (!state) return;

      if (window.innerWidth < DESKTOP_MIN_WIDTH) {
        reset(state, section);
        return;
      }

      const count = state.cards.length;
      const transitions = Math.max(count - 1, 1);
      const rect = section.getBoundingClientRect();
      const progress = clamp((state.stickyOffset - rect.top) / state.scrollDistance, 0, 1);
      const stepProgress = count > 1 ? progress * transitions : 0;
      const activeIndex = clamp(Math.round(stepProgress), 0, count - 1);

      state.cards.forEach((card, index) => {
        let y = 100;
        let scale = 1;

        if (index === 0) {
          y = -50;
          if (count > 1) scale = 1 - (1 - RESTING_SCALE) * clamp(stepProgress, 0, 1);
        } else {
          const entry = clamp(stepProgress - (index - 1), 0, 1);
          y = 100 - 150 * entry;

          if (stepProgress >= index) y = -50;
          if (index < count - 1) {
            scale = 1 - (1 - RESTING_SCALE) * clamp(stepProgress - index, 0, 1);
          }
        }

        card.style.transform = `translate3d(-50%, ${y}%, 0) scale(${scale})`;
        card.style.zIndex = String(index + 1);
        card.classList.toggle('is-active', index === activeIndex);
      });

      state.copyLayers.forEach((copy, index) => {
        const distance = Math.abs(stepProgress - index);
        const opacity = clamp(1 - distance * 1.45, 0, 1);
        const y = (index - stepProgress) * 20;

        copy.style.opacity = opacity;
        copy.style.transform = `translate3d(0, ${y}px, 0)`;
        copy.classList.toggle('is-active', index === activeIndex);
      });

      if (state.progress) {
        state.progress.style.transform = `scaleX(${MIN_PROGRESS_SCALE + progress * (1 - MIN_PROGRESS_SCALE)})`;
      }
    }

    function measure(section) {
      const state = states.get(section);
      if (!state) return;

      if (window.innerWidth < DESKTOP_MIN_WIDTH || state.cards.length <= 1) {
        reset(state, section);
        return;
      }

      const stickyOffset = getStickyOffset();
      const pinHeight = Math.max(window.innerHeight - stickyOffset, 1);
      const scrollDistance = Math.max((state.cards.length - 1) * window.innerHeight * 0.95, window.innerHeight);

      state.stickyOffset = stickyOffset;
      state.scrollDistance = scrollDistance;
      state.pin.style.height = `${pinHeight}px`;
      section.style.minHeight = `${pinHeight + scrollDistance}px`;
      update(section);
    }

    function bind(section) {
      if (states.has(section)) return;

      const pin = section.querySelector('[data-door-pin]');
      const cards = Array.from(section.querySelectorAll('[data-door-card]'));
      const copyLayers = Array.from(section.querySelectorAll('[data-door-copy]'));
      const progress = section.querySelector('[data-door-progress]');

      if (!pin || !cards.length) return;

      states.set(section, {
        cards,
        copyLayers,
        pin,
        progress,
        scrollDistance: 1,
        stickyOffset: 0
      });

      measure(section);
    }

    function init(scope) {
      scope.querySelectorAll('[data-home-door-signs]').forEach(bind);
    }

    const runMeasure = () => {
      document.querySelectorAll('[data-home-door-signs]').forEach(measure);
    };

    const runUpdate = () => {
      document.querySelectorAll('[data-home-door-signs]').forEach(update);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    window.addEventListener('load', runMeasure);
    window.addEventListener('resize', runMeasure);
    window.addEventListener('scroll', runUpdate, { passive: true });

    if ('MutationObserver' in window) {
      const rootStyleObserver = new MutationObserver(runMeasure);
      rootStyleObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
      runMeasure();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-explore-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const states = new WeakMap();
    const DESKTOP_SCROLL_FACTOR = 1.55;
    const MIN_PROGRESS_SCALE = 0.08;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function updateMobileProgress(section) {
      const state = states.get(section);
      if (!state) return;
      const { windowEl, fill } = state;
      const scrollable = windowEl.scrollHeight - windowEl.clientHeight;
      const progress = scrollable > 0 ? Math.min(windowEl.scrollTop / scrollable, 1) : 0;
      const viewportHeight = windowEl.clientHeight;
      const thumbHeight = windowEl.scrollHeight > 0 ? clamp((viewportHeight / windowEl.scrollHeight) * viewportHeight, 36, viewportHeight) : viewportHeight;
      const thumbOffset = scrollable > 0 ? progress * (viewportHeight - thumbHeight) : 0;

      fill.style.transform = `scaleX(${Math.max(progress, MIN_PROGRESS_SCALE)})`;
      section.style.setProperty('--home-explore-scrollbar-top', `${windowEl.offsetTop}px`);
      section.style.setProperty('--home-explore-scrollbar-height', `${viewportHeight}px`);
      section.style.setProperty('--home-explore-scrollbar-thumb-height', `${thumbHeight}px`);
      section.style.setProperty('--home-explore-scrollbar-thumb-offset', `${thumbOffset}px`);
    }

    function update(section) {
      const state = states.get(section);
      if (!state) return;

      if (window.innerWidth <= 1024) {
        state.track.style.transform = '';
        updateMobileProgress(section);
        return;
      }

      const rect = section.getBoundingClientRect();
      const scrollable = Math.max(state.scrollDistance, section.offsetHeight - window.innerHeight, 1);
      const progress = clamp(-rect.top / scrollable, 0, 1);

      state.track.style.transform = `translate3d(0, ${state.maxTranslate * -progress}px, 0)`;
      state.fill.style.transform = `scaleX(${Math.max(progress, MIN_PROGRESS_SCALE)})`;
    }

    function measure(section) {
      const state = states.get(section);
      if (!state) return;

      if (window.innerWidth <= 1024) {
        state.pin.style.height = 'auto';
        section.style.minHeight = '0px';
        section.style.removeProperty('--home-explore-progress-offset');
        update(section);
        return;
      }

      const viewportHeight = state.windowEl.offsetHeight;
      const trackHeight = state.track.scrollHeight;
      const maxTranslate = Math.max(trackHeight - viewportHeight, 0);
      const scrollDistance = maxTranslate > 0 ? Math.max(maxTranslate * DESKTOP_SCROLL_FACTOR, window.innerHeight * 1.2) : 0;
      const endHold = maxTranslate > 0 ? Math.min(Math.max(window.innerHeight * 0.35, 260), 640) : 0;
      const cards = Array.from(state.track.querySelectorAll('.home-explore__card'));
      const targetCard = cards
        .slice()
        .reverse()
        .find((card) => card.offsetTop + card.offsetHeight <= viewportHeight + 1);
      const titleHeight = state.title ? state.title.offsetHeight : 0;
      const targetBottom = targetCard ? targetCard.offsetTop + targetCard.offsetHeight : viewportHeight * 0.65;
      const introHeight = state.intro.offsetHeight;
      const progressHeight = state.progress.offsetHeight;
      const maxProgressOffset = Math.max(introHeight - titleHeight - progressHeight, 0);
      const progressOffset = clamp((targetBottom * 2) - introHeight - titleHeight + progressHeight, 0, maxProgressOffset);

      state.maxTranslate = maxTranslate;
      state.scrollDistance = scrollDistance;
      state.pin.style.height = `${window.innerHeight}px`;
      section.style.minHeight = `${window.innerHeight + scrollDistance + endHold}px`;
      section.style.setProperty('--home-explore-progress-offset', `${progressOffset}px`);
      update(section);
    }

    function bind(section) {
      if (states.has(section)) return;

      const track = section.querySelector('.home-explore__track');
      const pin = section.querySelector('.home-explore__pin');
      const windowEl = section.querySelector('.home-explore__rail-window');
      const intro = section.querySelector('.home-explore__intro');
      const progress = section.querySelector('.home-explore__progress');
      const fill = section.querySelector('.home-explore__progress-fill');
      const title = section.querySelector('.home-explore__title');

      if (!track || !windowEl || !intro || !progress || !fill || !pin) return;

      states.set(section, { fill, intro, maxTranslate: 0, pin, progress, scrollDistance: 1, title, track, windowEl });

      windowEl.addEventListener('scroll', () => updateMobileProgress(section), { passive: true });

      measure(section);
    }

    function init(scope) {
      scope.querySelectorAll('[data-home-explore]').forEach(bind);
    }

    const runMeasure = () => {
      document.querySelectorAll('[data-home-explore]').forEach(measure);
    };

    const runUpdate = () => {
      document.querySelectorAll('[data-home-explore]').forEach(update);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    window.addEventListener('load', runMeasure);
    window.addEventListener('scroll', runUpdate, { passive: true });
    window.addEventListener('resize', runMeasure);

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
      runMeasure();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const MOBILE_BREAKPOINT = 1024;
    const scheduledScopes = new WeakSet();

    function getSections(scope) {
      if (!scope) return [];
      if (scope.matches && scope.matches('[data-home-feature]')) return [scope];
      return Array.from(scope.querySelectorAll('[data-home-feature]'));
    }

    function getViewportMode() {
      return window.innerWidth <= MOBILE_BREAKPOINT ? 'mobile' : 'desktop';
    }

    function syncThumbA11y(section, index) {
      const thumbs = section.querySelectorAll('.home-feature__thumb');
      thumbs.forEach((thumb, thumbIndex) => {
        if (thumbIndex === index) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    function getProductSlide(section, source) {
      if (source && source.nodeType === 1) {
        return source.closest('.home-feature__hero-slide');
      }

      const index = Number(source);
      if (!Number.isFinite(index)) return null;

      const slides = Array.from(section.querySelectorAll('.home-feature__hero-slide'));
      const indexedSlide = slides.find((slide) => Number(slide.dataset.productIndex) === index);

      return indexedSlide || slides[index] || null;
    }

    function syncProductCopy(section, source) {
      const slide = getProductSlide(section, source);
      if (!slide) return;

      const titleEl = section.querySelector('[data-home-feature-title]');
      const priceEl = section.querySelector('[data-home-feature-price]');
      const buttonEl = section.querySelector('[data-home-feature-button]');

      if (titleEl && Object.prototype.hasOwnProperty.call(slide.dataset, 'productTitle')) {
        titleEl.textContent = slide.dataset.productTitle;
      }

      if (priceEl && Object.prototype.hasOwnProperty.call(slide.dataset, 'productPrice')) {
        priceEl.textContent = slide.dataset.productPrice;
      }

      if (buttonEl && Object.prototype.hasOwnProperty.call(slide.dataset, 'productUrl')) {
        buttonEl.setAttribute('href', slide.dataset.productUrl);
      }
    }

    function getActiveProductSlide(section, swiper) {
      return (
        swiper.slides[swiper.activeIndex] ||
        section.querySelector('.home-feature__hero-slide.swiper-slide-active') ||
        getProductSlide(section, swiper.realIndex || 0)
      );
    }

    function getThumbGap(section) {
      const value = parseFloat(getComputedStyle(section).getPropertyValue('--home-feature-thumb-slide-gap'));
      return Number.isFinite(value) ? value : 10;
    }

    function waitForSwiper(callback, attempt = 0) {
      if (typeof window.Swiper === 'function') {
        callback();
        return;
      }

      if (attempt >= 120) return;

      window.setTimeout(() => waitForSwiper(callback, attempt + 1), 50);
    }

    function destroy(scope) {
      getSections(scope).forEach((section) => {
        const instance = instances.get(section);
        if (!instance) return;

        if (instance.syncThumbGap) {
          window.removeEventListener('resize', instance.syncThumbGap);
        }
        if (instance.thumbClickHandler && instance.thumbsEl) {
          instance.thumbsEl.removeEventListener('click', instance.thumbClickHandler);
        }
        if (instance.hero) instance.hero.destroy(true, true);
        if (instance.thumbs) instance.thumbs.destroy(true, true);

        instances.delete(section);
        delete section.dataset.featureReady;
      });
    }

    function init(scope) {
      getSections(scope).forEach((section) => {
        if (instances.has(section)) return;

        const heroEl = section.querySelector('[data-home-feature-gallery]');
        const thumbsEl = section.querySelector('[data-home-feature-thumbs]');
        const prevEl = section.querySelector('[data-home-feature-prev]');
        const nextEl = section.querySelector('[data-home-feature-next]');
        const mode = getViewportMode();
        const isMobile = mode === 'mobile';
        const slideCount = heroEl ? heroEl.querySelectorAll('.swiper-slide').length : 0;

        if (!heroEl) {
          section.dataset.featureReady = 'true';
          return;
        }

        let thumbsSwiper = null;
        let syncThumbGap = null;

        if (!isMobile && thumbsEl && thumbsEl.querySelectorAll('.swiper-slide').length > 1) {
          thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 'auto',
            slideToClickedSlide: true,
            speed: 550,
            spaceBetween: getThumbGap(section),
            watchSlidesProgress: true,
          });

          syncThumbGap = () => {
            const nextGap = getThumbGap(section);
            if (thumbsSwiper.params.spaceBetween === nextGap) return;

            thumbsSwiper.params.spaceBetween = nextGap;
            thumbsSwiper.originalParams.spaceBetween = nextGap;
            thumbsSwiper.update();
          };

          window.addEventListener('resize', syncThumbGap);
        }

        const heroOptions = isMobile
          ? {
              centeredSlides: true,
              loop: false,
              slidesPerView: 'auto',
              spaceBetween: 14,
              speed: 550
            }
          : {
              slidesPerView: 1,
              spaceBetween: 0,
              speed: 550
            };

        if (thumbsSwiper) {
          heroOptions.thumbs = {
            swiper: thumbsSwiper
          };
        }

        if (prevEl && nextEl) {
          heroOptions.navigation = {
            prevEl,
            nextEl
          };
        }

        const heroSwiper = new Swiper(heroEl, heroOptions);
        let thumbClickHandler = null;

        if (thumbsEl && thumbsSwiper) {
          thumbClickHandler = (event) => {
            const slide = event.target.closest('.home-feature__thumb-slide');
            if (!slide || !thumbsEl.contains(slide)) return;

            event.preventDefault();

            const slides = Array.from(thumbsEl.querySelectorAll('.home-feature__thumb-slide'));
            const index = slides.indexOf(slide);
            if (index < 0) return;

            if (heroSwiper.params.loop && typeof heroSwiper.slideToLoop === 'function') {
              heroSwiper.slideToLoop(index);
            } else {
              heroSwiper.slideTo(index);
            }
            thumbsSwiper.slideTo(index);
            syncThumbA11y(section, index);
            syncProductCopy(section, index);
          };

          thumbsEl.addEventListener('click', thumbClickHandler);
        }

        const syncActiveProduct = () => {
          const index = heroSwiper.realIndex || 0;
          syncThumbA11y(section, index);
          syncProductCopy(section, getActiveProductSlide(section, heroSwiper));
        };

        syncActiveProduct();
        heroSwiper.on('slideChange', syncActiveProduct);
        heroSwiper.on('realIndexChange', syncActiveProduct);
        heroSwiper.on('loopFix', syncActiveProduct);
        heroSwiper.on('slideChangeTransitionEnd', syncActiveProduct);

        instances.set(section, {
          hero: heroSwiper,
          mode,
          thumbClickHandler,
          thumbs: thumbsSwiper,
          thumbsEl,
          syncThumbGap
        });

        section.dataset.featureReady = 'true';
      });
    }

    function scheduleInit(scope) {
      if (!scope || scheduledScopes.has(scope)) return;

      scheduledScopes.add(scope);

      waitForSwiper(() => {
        scheduledScopes.delete(scope);
        init(scope);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scheduleInit(document), { once: true });
    } else {
      scheduleInit(document);
    }

    window.addEventListener('resize', () => {
      getSections(document).forEach((section) => {
        const instance = instances.get(section);
        if (!instance) return;

        const nextMode = getViewportMode();
        if (instance.mode !== nextMode) {
          destroy(section);
          scheduleInit(section);
          return;
        }

        if (instance.hero) instance.hero.update();
        if (instance.thumbs) instance.thumbs.update();
      });
    });

    document.addEventListener('shopify:section:load', (event) => scheduleInit(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-launches"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getElements = (scope, selector) => {
      const elements = Array.from(scope.querySelectorAll(selector));

      if (scope instanceof Element && scope.matches(selector)) {
        elements.unshift(scope);
      }

      return elements;
    };

    const initializeGalleryDrag = (scope) => {
      getElements(scope, '.new-product-launches__gallery').forEach((gallery) => {
        if (gallery.dataset.mouseDragInitialized === 'true') return;

        gallery.dataset.mouseDragInitialized = 'true';

        let activePointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let isDragging = false;

        const finishDrag = () => {
          const pointerId = activePointerId;

          activePointerId = null;
          isDragging = false;
          gallery.classList.remove('is-dragging');

          if (pointerId !== null && gallery.hasPointerCapture(pointerId)) {
            gallery.releasePointerCapture(pointerId);
          }
        };

        gallery.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (gallery.scrollWidth <= gallery.clientWidth) return;

          activePointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = gallery.scrollLeft;
          isDragging = false;
          gallery.setPointerCapture(event.pointerId);
        });

        gallery.addEventListener('pointermove', (event) => {
          if (event.pointerId !== activePointerId) return;

          const distance = event.clientX - startX;

          if (!isDragging && Math.abs(distance) >= 4) {
            isDragging = true;
            gallery.classList.add('is-dragging');
          }

          if (!isDragging) return;

          event.preventDefault();
          gallery.scrollLeft = startScrollLeft - distance;
        });

        gallery.addEventListener('pointerup', finishDrag);
        gallery.addEventListener('pointercancel', finishDrag);
        gallery.addEventListener('lostpointercapture', finishDrag);
      });
    };

    const initialize = (scope = document) => initializeGalleryDrag(scope);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
